import { render, staticRenderFns } from "./split-view.vue?vue&type=template&id=60290087&scoped=true&"
import script from "./split-view.vue?vue&type=script&lang=ts&"
export * from "./split-view.vue?vue&type=script&lang=ts&"
import style0 from "./split-view.vue?vue&type=style&index=0&id=60290087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60290087",
  null
  
)

export default component.exports